export const CampaignPurpose = {
  All: -1,
  Business: 1,
  Istitutional: 2,
};

export type CampaignPurposeType = typeof CampaignPurpose;

export const formatCampaignPurpose = (stato: number) => {
  switch (stato) {
    case CampaignPurpose.Business:
      return 'Commerciale';
    case CampaignPurpose.Istitutional:
      return 'Istituzionale';
    default:
      return 'Sconosciuto';
  }
};
